import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "alert-container" }
const _hoisted_3 = { class: "r-grid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "pipe" }, "|", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "pipe" }, "|", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_UpdateApp = _resolveComponent("UpdateApp")!
  const _component_plusSVG = _resolveComponent("plusSVG")!
  const _component_alert = _resolveComponent("alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_AppHeader, { userInfoData: _ctx.userInfoData }, null, 8, ["userInfoData"]),
    _createVNode(_component_UpdateApp),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alerts, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_alert, {
            key: index,
            item: item,
            index: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_plusSVG, {
                class: "close-message",
                onClick: ($event: any) => {_ctx.alerts.splice(index, 1);}
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["item", "index"])), [
            [_vShow, _ctx.alerts.length > 0]
          ])
        }), 128))
      ]),
      (_ctx.persistentAlerts)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.persistentAlerts, (alert, index) => {
            return _withDirectives((_openBlock(), _createBlock("div", {
              class: "r-grid persistent-alert",
              key: index
            }, [
              _createTextVNode(_toDisplayString(alert.value.message) + " ", 1),
              _createVNode(_component_plusSVG, {
                class: "close-message",
                onClick: ($event: any) => {_ctx.persistentAlerts.splice(index, 1);}
              }, null, 8, ["onClick"])
            ], 512)), [
              [_vShow, alert.value.route ? alert.value.route.includes(this.$route.name) : true]
            ])
          }), 128))
        : _createCommentVNode("", true),
      _createVNode(_component_Breadcrumbs),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.$route.name !== 'Manage Single Employee'
    && _ctx.$route.name !== 'Employee Leave Item'
    && _ctx.$route.name !== 'Employee Leave Balance'
    && _ctx.$route.name !== 'Logout')
        ? (_openBlock(), _createBlock(_component_UserInfo, {
            key: 2,
            userInfoData: _ctx.userInfoData,
            userCalendarsData: _ctx.userCalendarsData
          }, null, 8, ["userInfoData", "userCalendarsData"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, { userInfoData: _ctx.userInfoData }, null, 8, ["userInfoData"])
    ]),
    _createVNode("footer", null, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", null, " © " + _toDisplayString(new Date().getFullYear()) + " The Board of Trustees of the University of Illinois ", 1),
        _hoisted_4,
        _createVNode("span", null, "UIC GoTime v" + _toDisplayString(_ctx.$store.getters.appVersion), 1),
        _hoisted_5,
        _createVNode("span", null, "API v" + _toDisplayString(_ctx.$store.state.apiVersion), 1)
      ])
    ])
  ]))
}